import React from 'react';
import { Box, Chip } from '@mui/material';
import { createStyleSheet } from 'utils/helpers';
import CustomerConstants from '../constants';

const decideComponentStatus = (status: string) => {
    switch (status) {
        case CustomerConstants.status.INACTIVE:
            return (
                <Box sx={styles.boxStatus}>
                    <Chip
                        label="Đã khóa"
                        color="error"
                        size="small"
                        sx={{
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '16.94px',
                            color: '#FA5A7D',
                            background: '#FFEAED',
                            p: 2,
                            borderRadius: '5px',
                        }}
                    />
                </Box>
            );
        case CustomerConstants.status.ACTIVE:
            return (
                <Box sx={styles.boxStatus}>
                    <Chip
                        label="Đang hoạt động"
                        color="success"
                        size="small"
                        sx={{
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '16.94px',
                            color: '#13B75B',
                            background: '#DDFFEB',
                            p: 2,
                            borderRadius: '5px',
                        }}
                    />
                </Box>
            );
    }
};

const CustomerStatus: React.FC<{ status: string }> = ({ status }) => {
    return <>{decideComponentStatus(status)}</>;
};
const styles = createStyleSheet({
    boxStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    textStatus: {
        fontSize: '14px',
        lineHeight: '17px',
    },
});
export default CustomerStatus;
